// extracted by mini-css-extract-plugin
export default {"screen":"screen__6eba4bf4","signUp-area":"signUp-area__a3ae085b"};